import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-text">TRATTY</span>
              <span className="footer-logo-subtitle">PROFESSIONALS</span>
            </div>
            <p className="footer-tagline">
              Cuidados superiores para os cabelos com ingredientes naturais e orgânicos.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Navegação</h4>
              <a href="#home">Home</a>
              <a href="#products">Produtos</a>
              <a href="#about">Sobre</a>
              <a href="#contact">Contato</a>
            </div>

            <div className="footer-column">
              <h4>Contato</h4>
              <a href="tel:+5519974085161">(19) 9 7408-5161</a>
              <a href="mailto:contato@tratty.com.br">contato@tratty.com.br</a>
              <a href="https://www.instagram.com/trattyprofessionals" target="_blank" rel="noopener noreferrer">@trattyprofessionals</a>
              <a href="https://www.tratty.com.br" target="_blank" rel="noopener noreferrer">tratty.com.br</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-copyright">
            &copy; {currentYear} Tratty Professionals. Todos os direitos reservados.
          </p>
          <div className="footer-back-to-top">
            <a href="#home" className="btn btn-outline-light" aria-label="Voltar ao início">
              <i className="bi bi-arrow-up me-2" aria-hidden="true"></i>
              Voltar ao topo
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
